import { useEffect, useState } from 'react'
import { api } from '../../../lib/api.js'
import { toast } from 'sonner'

export function useKelas() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(null)

  const load = async (page = 1, filters = {}) => {
    setLoading(true)
    try {
      const params = { page, ...filters }
      const { data } = await api.get('/admin/kelas', { params })
      setItems(data.data.data || data.data)
      setPagination(data.data)
    } finally { setLoading(false) }
  }

  useEffect(() => { load(1) }, [])

  // Optimistic toggle — flip locally, sync server state, revert on error
  const toggleActive = async (item) => {
    setItems((prev) => prev.map((x) => x.id === item.id ? { ...x, is_active: !x.is_active } : x))
    try {
      const { data } = await api.patch(`/admin/kelas/${item.id}/toggle-active`)
      setItems((prev) => prev.map((x) => x.id === item.id ? { ...x, ...data.data } : x))
      toast.success(item.is_active ? 'Kelas dinonaktifkan' : 'Kelas diaktifkan')
    } catch (err) {
      setItems((prev) => prev.map((x) => x.id === item.id ? { ...x, is_active: item.is_active } : x))
      toast.error(err.response?.data?.message || 'Gagal mengubah status')
    }
  }

  // Optimistic remove
  const remove = async (item) => {
    if (!confirm(`Hapus kelas "${item.title}"?`)) return
    setItems((prev) => prev.filter((x) => x.id !== item.id))
    try {
      await api.delete(`/admin/kelas/${item.id}`)
      toast.success('Berhasil dihapus')
    } catch (err) {
      load(pagination?.current_page ?? 1)
      toast.error(err.response?.data?.message || 'Gagal menghapus')
    }
  }

  const save = async (form) => {
    const fd = new FormData()
    fd.append('title', form.title)
    if (form.deskripsi) fd.append('deskripsi', form.deskripsi)
    fd.append('kategori', JSON.stringify(form.kategori))
    fd.append('rating', form.rating)
    if (form.link_daftar) fd.append('link_daftar', form.link_daftar)
    fd.append('is_active', form.is_active ? '1' : '0')
    fd.append('sort_order', form.sort_order)
    if (form.image) fd.append('image', form.image)

    try {
      if (form.isNew) {
        await api.post('/admin/kelas', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        toast.success('Kelas berhasil dibuat')
      } else {
        await api.post(`/admin/kelas/${form.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        toast.success('Kelas berhasil diperbarui')
      }
      load(1)
    } catch (err) { toast.error(err.response?.data?.message || 'Gagal menyimpan') }
  }

  return { items, loading, pagination, load, toggleActive, remove, save }
}
